(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop-promo.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop-promo.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useMemo = _React.useMemo;
const _svs$bingo_react$comp = svs.bingo_react.components.bingoCard,
  CardImage = _svs$bingo_react$comp.CardImage,
  InfoItem = _svs$bingo_react$comp.InfoItem,
  JackpotRibbon = _svs$bingo_react$comp.JackpotRibbon,
  HostFlerp = _svs$bingo_react$comp.HostFlerp,
  HoverOverlay = _svs$bingo_react$comp.HoverOverlay,
  WinAnim = _svs$bingo_react$comp.WinAnim;
const Image = svs.content.image_v2.Image;
const cmsGames = svs.bingo_react.data.cmsGames;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const _svs$bingo_react$comp2 = svs.bingo_react.components.common,
  getBingoCardAriaLabel = _svs$bingo_react$comp2.accessibilityHelpers.getBingoCardAriaLabel,
  PlayMode = _svs$bingo_react$comp2.constants.PlayMode;
const useStartTimer = svs.bingo_react.components.useStartTimer;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const BingoCardDesktopPromo = _ref => {
  let className = _ref.className,
    _ref$gameData = _ref.gameData,
    gameId = _ref$gameData.id,
    badgeText = _ref$gameData.badgeText,
    host = _ref$gameData.host,
    jackpotAmount = _ref$gameData.jackpotAmount,
    startTime = _ref$gameData.startTime,
    subTitle = _ref$gameData.subTitle,
    price = _ref$gameData.price,
    players = _ref$gameData.players,
    title = _ref$gameData.title,
    status = _ref$gameData.status,
    playMode = _ref$gameData.playMode,
    lastWinTimestamp = _ref.lastWinTimestamp;
  const classList = ['bingo-card-desktop-promo'];
  classList.push(className);
  classList.push('svs-keyboard-focus');
  const promoPosition = 1;
  const isMultiPlayer = useMemo(() => playMode === PlayMode.Multi, [playMode]);
  const timer = useStartTimer(startTime, status);
  const ariaLabel = useMemo(() => getBingoCardAriaLabel({
    title,
    bingoCardPrice: price,
    players: isMultiPlayer ? players : null,
    addTimer: isMultiPlayer,
    timer,
    status,
    jackpotAmount
  }), [title, price, players, isMultiPlayer, timer, status, jackpotAmount]);
  const imgSrc = useMemo(() => {
    const cmsData = cmsGames.find(cmsGame => cmsGame.id === gameId);
    return _objectSpread(_objectSpread({}, cmsData.backgroundImage), {}, {
      fitWrapper: true,
      aspectRatio: {
        height: 354,
        width: 519
      }
    });
  }, [gameId]);

  const memoizedImage = useMemo(() => {
    if (!imgSrc) return null;
    return React.createElement(Image, {
      cssSelectors: "card-desktop-promo-right-content__image",
      fitWrapper: true,
      image: imgSrc,
      key: gameId
    });
  }, [gameId]); 

  return React.createElement(Card, {
    "aria-label": ariaLabel,
    className: classList.join(' '),
    Component: "a",
    "data-area-name": promoPosition,
    "data-impression": "true",
    "data-impression-tracking": "bingo-card-".concat(promoPosition),
    onClick: () => startBingoGame(gameId, promoPosition),
    onKeyDown: e => e.key === 'Enter' && startBingoGame(gameId),
    role: "button",
    tabIndex: 0
  }, React.createElement(CardBody, {
    className: "bingo-card-desktop-promo__body"
  }, jackpotAmount && React.createElement(JackpotRibbon, {
    jackpotAmount: jackpotAmount
  }), React.createElement("div", {
    className: "bingo-card-desktop-promo-left-content"
  }, React.createElement(CardImage, {
    badgeText: badgeText,
    renderHoverOverlay: false,
    showTimer: isMultiPlayer,
    startTime: startTime,
    status: status,
    subTitle: subTitle,
    title: title
  }), React.createElement("div", {
    className: "bingo-card-desktop-promo-left-content__info"
  }, React.createElement(InfoItem, {
    bold: true,
    icon: "".concat(isMultiPlayer ? 'players' : 'user'),
    label: "".concat(isMultiPlayer ? "".concat(players, " st") : '')
  }), React.createElement(InfoItem, {
    bold: true,
    icon: "money",
    label: "".concat(price, " kr")
  }))), React.createElement("div", {
    className: "bingo-card-desktop-promo-right-content"
  }, host && React.createElement(HostFlerp, {
    hostName: host.name
  }), imgSrc ? memoizedImage : React.createElement(Image, {
    cssSelectors: "bingo-card-desktop-promo-right-content__image",
    fitWrapper: true,
    image: imgSrc,
    key: gameId
  }), React.createElement(WinAnim, {
    lastWinTimestamp: lastWinTimestamp
  }), React.createElement(HoverOverlay, {
    gameId: gameId,
    promoPosition: promoPosition
  }))));
};
setGlobal('svs.bingo_react.components.bingoCard.BingoCardDesktopPromo', BingoCardDesktopPromo);

 })(window);